





























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {
    ReconVehicleDetail,
    ReviveNote,
    TenantInfo,
} from '@/models/inventory/vehiclerevivestep';
import { Base } from '@/components/common/base';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import {vehicleReconStepService} from '@/shared';

@Component({
    props: ['recordKey'],
    components: {
        AppGrid: () =>
            import('@/components/common/app.grid.vue'),
        Note: () => import('./note.component.vue'),
        AppDialog: () =>
            import('@/components/common/app.dialog.vue'),
    },
})

export default class VehicleDahboardPage extends Base {
    public dashboardDetails: any;
    public smDevice: string = 'col-sm-6';
    public mdDevice: string = 'col-md-4';
    public ldDevice: string = 'col-ld-2';
    public paginationWithTwoRecords: PaginationModel = new PaginationModel('id', false, 2);
    public paginationWithFiveRecords: PaginationModel = new PaginationModel('id', false, 5);
    public pagesWithTwoRecords: any[] = [2];
    public pagesWithFiveRecords: any[] = [2, 5];
    public colors: any = [
        '#4287f5',
        '#9042f5',
        '#f542a1',
        '#ba603a',
        '#4b9c25',
        '#8e259c',
        '#9c2531',
        '#13b06c',
        '#91ba3a',
        '#ba803a',
        '#1384b0',
        '#b04713',
        '#b08913',
        '#13b0ad',
        '#9c2531',
        '#13b06c',
        '#91ba3a',
        '#ba803a',
        '#1384b0',
        '#b04713',
        '#b08913',
        '#13b0ad',
    ];
    public details: any = [];
    public tenantInfo: TenantInfo = {
        tenantId: 0,
        enterpriseId: 0,
        storeId: 0,
    };
    public recordKey: string;
    public headers: VHeaders[] = [
        {
            text: this.$parent.$t('vehicleDahboard.stockDuration') as string,
            align: 'center',
            style: 'font-size:20px',
            value: 'stockNumber',
            filters: [
                (val, item) => {
                    return item.stockNumber + ' - (' + item.duration + ')';
                },
            ],
        },
    ];
    public funcForRepeat: number;
    public isAnonymousUser: boolean = false;

    public mounted() {
        this.$store.dispatch('setPageTitle', this.$route.meta.title);

        const storeId = this.userSession.storeId || Number(this.$route.params.storeId || '0');

        this.tenantInfo = {
            tenantId: this.userSession.tenantId || Number(this.$route.params.tenantId),
            enterpriseId: this.userSession.enterpriseId || Number(this.$route.params.enterpriseId),
            storeId,
        };

        if (this.$route.params.userId) {
            this.isAnonymousUser = true;
            this.funcForRepeat = window.setInterval(
                function() {
                    this.getDetails(this.$route.params.vehicleType);
                }.bind(this),
                30000,
            );

        } else {
            this.$watch('recordKey', (newVal, oldVal) => {
                if (newVal) {

                    this.openFullscreen();
                    this.getDetails(newVal);
                    this.funcForRepeat = window.setInterval(
                        function() {
                            this.getDetails(this.recordKey);
                        }.bind(this),
                        30000,
                    );
                } else {
                    clearTimeout(this.funcForRepeat);
                    return;
                }
            });
        }

    }
    public beforeDestroy() {
        clearTimeout(this.funcForRepeat);
    }
    public async getDetails(vehicleType: string): Promise<void> {
        const response = await vehicleReconStepService.getDashboardDetails(
            vehicleType,
            this.tenantInfo,
            this.$route.params.dashboardId,
            this.$route.params.userId,
        );
        this.details = response;
        let i = 0;
        this.details.map((item) => {
            item.color = this.colors[i];
            i++;
            if (item.hasInspectionDetails) {
                const indexOfItem = item.steps.find((element) => element.stepId === item.inspectionStepId);
                item.steps.splice(
                    item.steps.indexOf(indexOfItem) + 1, 0, { inspectionStepId: item.inspectionStepId });
            }
            return item;
        });

        const itemCount = this.details.length;
        if (itemCount < 4) {
            this.smDevice = 'col-sm-' + 12 / itemCount;
            this.mdDevice = 'col-md-' + 12 / itemCount;
            this.ldDevice = 'col-ld-' + 12 / itemCount;
        } else {
            this.smDevice = 'col-sm-3';
            if (itemCount > 9) {
                this.mdDevice = 'col-md-2';
            } else {
                this.mdDevice = 'col-md-4' + Math.round(12 / itemCount);
            }
            if (itemCount > 12) {
                this.ldDevice = 'col-ld-1';
            } else {
                this.ldDevice = 'col-ld-' + Math.round(12 / itemCount);
            }
        }
    }

    public getFontSize(numberOfSteps: number) {
        if (numberOfSteps < 4) {
            return '4vw !important';
        } else if (numberOfSteps >= 4 && numberOfSteps < 6) {
            return '2.2vw !important';
        } else if (numberOfSteps >= 6 && numberOfSteps < 12) {
            return '1vw !important';
        }
    }

    public getFontSizeForCount(numberOfSteps: number) {
        if (numberOfSteps < 2) {
            return '14vw !important';
        } else if (numberOfSteps < 4) {
            return '8vw !important';
        } else if (numberOfSteps >= 4 && numberOfSteps < 6) {
            return '4vw !important';
        } else if (numberOfSteps >= 6 && numberOfSteps < 12) {
            return '2.45vw !important';
        }
    }
    public openFullscreen() {
        const elem = document.documentElement as any;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else
            if (elem.mozRequestFullScreen) {
                /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                /* Chrome, Safari & Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                /* IE/Edge */
                elem.msRequestFullscreen();
            }
    }
    public closeFullscreen() {
        const doc = document as any;

        if (doc.exitFullscreen) {
            doc.exitFullscreen();
        } else if (doc.mozCancelFullScreen) {
            doc.mozCancelFullScreen();
        } else if (doc.webkitExitFullscreen) {
            doc.webkitExitFullscreen();
        } else if (doc.msExitFullscreen) {
            doc.msExitFullscreen();
        }
    }
    public closeDialog() {
        this.$emit('closedialog');
        this.closeFullscreen();
    }
}
